import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { getLocalstorageToken } from '../context/AuthHelper';
import GetRecords from '../lib/api/GetRecords';
import { APIS } from '../lib/constants/apis';
import { UseFetchStatesType } from '../lib/types/types';
import { removeDataKeys, removeNullDeep } from '../utils/helper';

function useFetchApplicationsForNachrichten(): UseFetchStatesType {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any[]>([]);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		// Fetch data
		const fetchData = async () => {
			try {
				const filter = {
					Antragstellende_Organisation: get(getLocalstorageToken(), 'organisationId'),
					Antragstatus_Antragstatus: { $ne: 'inBearbeitung' },
					Skizze: { id: { $null: true } },
				};
				const res = await GetRecords(APIS.Antrag, ['Foerderprogramm'], filter, [{ updatedAt: 'desc' }]);
				const result: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				setData(result);
			} catch (err: any) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	return { loading, data, error };
}
export { useFetchApplicationsForNachrichten };
